import { createTheme } from "@mui/material";

export const izakayaTheme = createTheme({
  palette: {
    primary: {
      //   light: "#07cece",
      main: "#B02E2E",
    },
  },
});
